import type { ReactNode } from 'react';
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@brimostech/ui';

interface SectionProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  /** Remove the inner padding (tables). */
  flush?: boolean;
}

export function Section({ title, description, actions, children, flush }: SectionProps) {
  return (
    <Card className={flush ? 'gap-4 pb-0' : undefined}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
        {actions ? <CardAction>{actions}</CardAction> : null}
      </CardHeader>
      <CardContent
        className={
          flush
            ? 'px-0 [&_.rounded-xl]:rounded-none [&_.rounded-xl]:border-x-0 [&_.rounded-xl]:border-b-0 [&_.rounded-xl]:shadow-none'
            : undefined
        }
      >
        {children}
      </CardContent>
    </Card>
  );
}
